/* IBRA store — tema Shopify */
(function () {
  'use strict';

  const strings = window.themeStrings || {};
  const routes = window.routes || {};

  /* Quantidade +/- */
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-qty-change]');
    if (!button) return;
    const wrapper = button.closest('.qty');
    const input = wrapper && wrapper.querySelector('input');
    if (!input) return;
    const step = parseInt(button.dataset.qtyChange, 10);
    const min = parseInt(input.min || '0', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Carrinho: enviar ao mudar quantidade */
  document.querySelectorAll('[data-cart-form] .qty input').forEach(function (input) {
    input.addEventListener('change', function () {
      clearTimeout(input._t);
      input._t = setTimeout(function () { input.form.submit(); }, 400);
    });
  });

  /* Filtros e ordenação: enviar automaticamente */
  document.querySelectorAll('[data-autosubmit]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Botão de filtros no mobile */
  document.querySelectorAll('[data-filters-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      const sidebar = document.querySelector('.collection-sidebar');
      const collapsed = sidebar.getAttribute('data-collapsed') === 'true';
      sidebar.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      button.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
    });
  });

  /* Menu mobile */
  const menu = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!menu) return;
      menu.setAttribute('open', '');
      b.setAttribute('aria-expanded', 'true');
      const first = menu.querySelector('a, button');
      if (first) first.focus();
    });
  });
  function closeMenu() {
    if (!menu) return;
    menu.removeAttribute('open');
    document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  document.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
  if (menu) {
    menu.addEventListener('click', function (e) { if (e.target === menu) closeMenu(); });
    menu.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  }

  /* Galeria do produto */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
        main.src = thumb.dataset.src;
        main.srcset = thumb.dataset.srcset || '';
        main.alt = thumb.dataset.alt || '';
      });
    });
  });

  function formatMoney(cents, format) {
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    const withSep = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    const noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (format || 'R$ {{amount_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withSep)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  /* Seletor de variantes */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    const dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const moneyFormat = root.dataset.moneyFormat;
    const installments = parseInt(root.dataset.installments || '1', 10);
    const idInput = root.querySelector('input[name="id"]');
    const submit = root.querySelector('[data-add-button]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const instEl = root.querySelector('[data-installments]');
    const skuEl = root.querySelector('[data-sku]');
    const fieldsets = root.querySelectorAll('[data-option-index]');
    const gallery = document.querySelector('[data-gallery]');

    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      const values = selected();
      fieldsets.forEach(function (fs, i) {
        const label = fs.querySelector('[data-selected-value]');
        if (label) label.textContent = values[i] || '';
      });
      const variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
      if (!variant) {
        submit.disabled = true;
        submit.textContent = strings.unavailable || 'Indisponível';
        return;
      }
      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? (strings.addToCart || 'Adicionar à sacola') : (strings.soldOut || 'Esgotado');
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
      if (compareEl) {
        compareEl.hidden = !(variant.compare_at_price > variant.price);
        compareEl.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price, moneyFormat) : '';
      }
      if (instEl && installments > 1) {
        instEl.textContent = instEl.dataset.template
          .replace('[count]', installments)
          .replace('[amount]', formatMoney(Math.round(variant.price / installments), moneyFormat));
      }
      if (skuEl) skuEl.textContent = variant.sku || '';
      if (variant.featured_media && gallery) {
        const thumb = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
  });

  /* Adicionar à sacola via AJAX */
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('[data-ajax-cart]') || !window.fetch) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const errorEl = form.querySelector('[data-form-error]');
    const original = button.textContent;
    button.disabled = true;
    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message);
        if (errorEl) errorEl.textContent = '';
        button.textContent = strings.added || 'Adicionado ✓';
        return fetch((routes.cart_url || '/cart') + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        setTimeout(function () { button.textContent = original; button.disabled = false; }, 1600);
      })
      .catch(function (err) {
        if (errorEl) errorEl.textContent = err.message;
        button.textContent = original;
        button.disabled = false;
      });
  });
})();
